import React from "react"
import { VoucherContainerV2 } from "./v2"
import { VoucherContainerV1 } from "./v1"

export const VoucherContainer = (props: any) => {
  if (process.env.COMPANY_CODE === "gama" || props?.v2) {
    return <VoucherContainerV2 {...props} />
  } else {
    return <VoucherContainerV1 {...props} />
  }
}
